export default __webpack_public_path__ + "static/media/Icon4.9edada3d.svg";